function dateFormat(fmt, date) {
  let ret;
  /*let opt = {
    "Y+": date.getFullYear().toString(),        // 年
    "m+": (date.getMonth() + 1).toString(),     // 月
    "d+": date.getDate().toString(),            // 日
    "H+": date.getHours().toString(),           // 时
    "M+": date.getMinutes().toString(),         // 分
    "S+": date.getSeconds().toString()          // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };*/
  let opt = {
    "y+": date.getFullYear().toString(),        // 年
    "M+": (date.getMonth() + 1).toString(),     // 月
    "d+": date.getDate().toString(),            // 日
    "H+": date.getHours().toString(),           // 时
    "m+": date.getMinutes().toString(),         // 分
    "s+": date.getSeconds().toString()          // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
    };
  };
  return fmt;
}

/**
 * 获取某年某月的总天数
 * @param {Number} year 获取天数的年份
 * @param {Number} month 获取天数的月份
 * @returns {Number}  返回总天数
 */
function getDaysOfMonth(year, month) {
  var date = new Date(year, month, 0);
  var days = date.getDate();
  return days;
}

/**
 * 获取当前月的总天数
 */
function getDays() {
  var date = new Date();
  //将当前月份加1，下移到下一个月
  date.setMonth(date.getMonth() + 1);
  //将当前的日期置为0，
  date.setDate(0);
  //再获取天数即取上个月的最后一天的天数
  var days = date.getDate();
  return days;
}

/**
 * 计算两个时间是否大于一个月
 * @param {String} starDate 进行比较的开始日期  例如：2017-07-08 2017/01/12  日期格式字符串
 * @param {String} endDate 进行比较的结束日期  例如：2017-07-08 2017/01/12  日期格式字符串
 * @returns {Boolean}
 */
function isInSameMonth(starDate, endDate) {
  //var sDate = new Date(starDate).getTime();
  //var eDate = new Date(endDate).getTime();
  var thisMothDays = 1000 * 3600 * 24 * getDays()

  if (eDate - sDate > thisMothDays) {
    return true
  } else {
    return false
  }
}


export default {
  dateFormat:function (fmt, date) {
      return dateFormat(fmt, date);
  },
  isInSameMonth:function (stratDate, endDate) {
    return isInSameMonth(stratDate, endDate);
  }

}



// WEBPACK FOOTER //
// ./src/api/date.js